import React, { Component } from 'react';

import { MSection, Title } from 'components/misc';
import {
    Row, Col
} from 'design-react-kit';
import { Helmet } from 'react-helmet';


export class PerfezionamentoPduPlu extends Component {

    render() {
        const title = 'Diplomi di perfezionamento Post Laurea e Post Diploma';
        return (
            <>
                <Helmet>
                    <title>{title}</title>
                    <meta property="og:title" content={title} />
                </Helmet>
                <MSection>
                    <Row>
                        <Col>
                            <Title>{title}</Title>
                            <Row>
                                <Col xs={12} sm={6} md={4} lg={4}>
                                    <div className="swiper-slide my-2">
                                        <div className="programme-card">
                                            <a className="programme-card__link" href="../corsi-mnemosine/PLU">
                                                <div className="programme-card__header">
                                                    <img className="programme-card__img" alt="Diplomi di perfezionamento post laurea" src="/img/courses/new/plu.jpg" />
                                                </div>
                                                <div className="programme-card__body">
                                                    <h4 className="programme-card__title">Diplomi di perfezionamento post laurea <br/><span class="small">1500 ore e 60 CFU</span></h4>
                                                    <h6 className="text-red  text-highlights">Da € 389</h6>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </Col>
                                <Col xs={12} sm={6} md={4} lg={4}>
                                    <div className="swiper-slide my-2">
                                        <div className="programme-card">
                                            <a className="programme-card__link" href="../corsi-mnemosine/PDU">
                                                <div className="programme-card__header">
                                                    <img className="programme-card__img" alt="Diplomi di perfezionamento post diploma" src="/img/courses/new/pd.jpg" />
                                                </div>
                                                <div className="programme-card__body">
                                                    <h4 className="programme-card__title">Diplomi di perfezionamento post diploma <br/><span class="small">1500 ore e 60 CFU</span></h4>
                                                    <h6 className="text-red  text-highlights">Da € 389</h6>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </MSection>
            </>);
    }
}